import React, { Component } from "react";
import "./style.scss";
import { Map, GreenTick } from "../images";
import { Link } from "react-router-dom";

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
    };
    this.close = this.close.bind(this);
  }

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        window.addEventListener("click", this.close);
      } else {
        window.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close(timeOut) {
    this.setState({
      listOpen: false,
    });
  }

  selectItem(city) {
    this.setState({
      listOpen: false,
    });
    this.props.selectCity(city);
  }

  toggleList(status) {
    if (status === 1) {
      this.setState({ listOpen: false });
    } else {
      this.setState({
        listOpen: true,
      });
    }
  }

  render(props) {
    const { cityList, selectedCity } = this.props;
    const { listOpen } = this.state;
    return (
      cityList && (
        <div
          className={["dd-wrapper"]}
          onClick={() => {
            this.toggleList(0);
          }}
        >
          <div className={["dd-header"]}>
            <Map />
            <div className={["dd-header-title"]}>
              {!!selectedCity && selectedCity.name}
            </div>
          </div>
          {!!selectedCity && (
            <ul
              className={[
                ["dd-list"],
                [listOpen === true ? "active" : ""],
              ].join(" ")}
              onClick={(e) => e.stopPropagation()}
            >
              {cityList.map((city, index) => (
                <Link
                  to={`/${index + 1}`}
                  key={index}
                  className={[
                    ["dd-list-item"],
                    [city.id === selectedCity.id && "selected"],
                  ].join(" ")}
                  onClick={() => this.selectItem(city)}
                >
                  {city.name}
                  {city.id === selectedCity.id && (
                    <span style={{ marginLeft: "auto" }}>
                      <GreenTick />
                    </span>
                  )}
                </Link>
              ))}
            </ul>
          )}
        </div>
      )
    );
  }
}

export default Dropdown;
